import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Card, Table, Button, Header, Icon, Modal, Popup } from 'semantic-ui-react';
import { round as _round, find as _find, join as _join, keyBy as _keyBy } from 'lodash';
import { showNotificationMessage } from '../../store/actions/reactNotification'
import { clearAcceptedNotification } from '../../store/actions/notifications';

import { SUCCESS, ERROR } from '../../constants/NotificationType';

import Pagination from '../../components/Pagination/Pagination';

import { markBidAsServiced } from '../../services/Project';
import { priceDisplay } from '../../helpers/price';

class AcceptedBidsPartial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bids: [],
      servicedBidId: 0,
      collapsed: true,
      loading: false,
      rowsPerPage: 10,
      activePage: 1,
      bidsCount: 0,
      accepted: []
    }
  }

  async componentDidMount() {
    this.refreshServiceBids();
  }

  async onPageChange(e, d) {
    await this.setState({ activePage: d.activePage });
    this.refreshServiceBids();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.appliedAcceptanceCode !== prevProps.appliedAcceptanceCode || prevProps.visitTime !== this.props.visitTime) {
      this.refreshServiceBids();
    }
  }
  refreshServiceBids = async () => {
    try {
      this.setState({ loading: true });
      const { service, appliedAcceptanceCode } = this.props;
      const { rowsPerPage, activePage } = this.state;
      const options = {
        serviceID: service.serviceID,
        limit: rowsPerPage,
        page: activePage,
        acceptanceCode: appliedAcceptanceCode
      }
      const { acceptedBids, count } = await this.props.getRequests(options).then(res => res.data);

      this.setState({ bids: acceptedBids, bidsCount: count[0] && count[0].count || 0, loading: false });
      this.props.clearAcceptedNotification(service.serviceID);
    } catch (error) {

    }
  }

  close = () => {
    this.setState({ servicedBidId: 0 });
  }

  markAsServiced = () => {
    const { servicedBidId } = this.state;
    markBidAsServiced(servicedBidId)
      .then((res) => {
        if (res.resStatus >= 400) {
          throw new Error(res.message);
        }
        this.props.showNotificationMessage(SUCCESS, 'Bid is marked as serviced.');
        this.setState({ servicedBidId: 0 })
        this.refreshServiceBids();
      })
      .catch((e) => {
        console.log('failed');
        this.props.showNotificationMessage(ERROR, e.message || 'Marking bid as serviced failed.');
      });
  }

  hasNotification = (service) => {
    const { accepted } = this.props;
    const keyAccepted = _keyBy(accepted, 'serviceID');
    return !!keyAccepted[service.serviceID];
  }

  applyPromoCode = (price, discountAmount, discountPercentage) => {

    if (discountAmount && parseInt(discountAmount) > 0) {
      return <React.Fragment>
        <span style={{ textDecoration: 'line-through' }}>{priceDisplay(price)}</span>&nbsp;&nbsp;
            <span>{priceDisplay((price - parseInt(discountAmount)))}</span>
      </React.Fragment>
    }
    else if (discountPercentage && parseInt(discountPercentage) > 0) {
      const amount = (parseInt(discountPercentage) / 100) * price;
      return <React.Fragment>
        <span style={{ textDecoration: 'line-through' }}>{priceDisplay(price)}</span>&nbsp;&nbsp;
            <span>{priceDisplay(price - amount)}</span>
      </React.Fragment>

    }
    else {
      return priceDisplay(price);
    }
  }

  render() {
    const { service } = this.props;
    const { collapsed, bids, loading, bidsCount, rowsPerPage, activePage, servicedBidId } = this.state;

    return (bids.length &&
      <Card fluid className="ProjectsBids">
        <Card.Content>
          <Header as="h1" floated="left">{service.name}</Header>
          {this.hasNotification(service) && <Icon loading size="small" color="red" style={{ position: "fixed" }} name="certificate"></Icon> || null}
          <div style={{ float: 'right' }}>
            <Popup content={collapsed ? 'Collapse requests.' : 'Expand requests.'} trigger={<Icon name={collapsed ? 'angle up' : 'angle down'} onClick={() => this.setState({ collapsed: !collapsed })} />} />
            <Popup content='Click to refresh requests.' trigger={<Icon name='refresh' loading={loading} onClick={this.refreshServiceBids} />} />
          </div>
        </Card.Content>
        {collapsed && (<Card.Content>
          <Table basic='very'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell width="2">Buyer</Table.HeaderCell>
                <Table.HeaderCell width="2">Phone</Table.HeaderCell>
                <Table.HeaderCell width="3">Quick Info</Table.HeaderCell>
                {/*<Table.HeaderCell width="2">Bid Date</Table.HeaderCell>*/}
                {/* <Table.HeaderCell>Price</Table.HeaderCell> */}
                <Table.HeaderCell width="2">Lead Generated On</Table.HeaderCell>
                {/*<Table.HeaderCell width="1">Acceptance Code</Table.HeaderCell>*/}
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {bids.map((bid, i) => {
                return (
                  <Table.Row key={`bids_${i}`}>
                    <Table.Cell>
                      <Button size="tiny" className="primary-button" onClick={() => this.props.setSBRID(bid.sbr.singleBuyerRequestID)}>Request Details</Button>
                    </Table.Cell>
                    <Table.Cell>{bid.buyer.firstName}</Table.Cell>
                    <Table.Cell>{bid.buyer.cellPhone}</Table.Cell>
                    <Table.Cell>{bid.sbr.quickInfo}</Table.Cell>
                    {/*<Table.Cell>{moment(bid.bid.bidOn).format('lll')}</Table.Cell>*/}
                    {/* <Table.Cell>{this.applyPromoCode(bid.bid.price, bid.sbr.discountAmount, bid.sbr.discountPercent)}</Table.Cell> */}
                    <Table.Cell>{moment(bid.accept.acceptedOn).format('lll')}</Table.Cell>
                    {/*<Table.Cell>{bid.accept.acceptanceCode}</Table.Cell>*/}
                    <Table.Cell>
                      {!bid.accept.servicedAt ? <Button size="tiny" className="primary-button" onClick={() => this.setState({ servicedBidId: bid.accept.acceptedBidID })}>Request Review</Button> : ''}
                    </Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
          <Pagination activePage={activePage} totalPages={bidsCount && bidsCount / rowsPerPage || 1} disabled={loading}
            onPageChange={(e, d) => this.onPageChange(e, d)}
          />
          <Modal size='mini' open={!!servicedBidId} onClose={this.close}>
            <Modal.Header>Service Job</Modal.Header>
            <Modal.Content>
              {/*<p>Do you want to mark bid as serviced?</p>*/}
              <p>Do you want to request a review?</p>
            </Modal.Content>
            <Modal.Actions>
              <Button negative content='Cancel' onClick={this.close} />
              <Button positive content='Yes' onClick={this.markAsServiced} />
            </Modal.Actions>
          </Modal>
        </Card.Content>)}
      </Card> || null
    );
  }
}


const mapStateToProps = ({ notification: { accepted } }) => {
  return { accepted };
}

const mapDispatchToProps = {
  showNotificationMessage,
  clearAcceptedNotification
}

export default connect(mapStateToProps, mapDispatchToProps)(AcceptedBidsPartial); 